import React, { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { selectedChatTypingUsersState } from "../../state/chatState";

const formatTypingLabel = (typers) => {
  if (!typers.length) {
    return "";
  }

  if (typers.length === 1) {
    return `${typers[0].userName} is typing...`;
  }

  if (typers.length === 2) {
    return `${typers[0].userName} and ${typers[1].userName} are typing...`;
  }

  return `${typers[0].userName} and ${typers.length - 1} others are typing...`;
};

const TypingIndicator = () => {
  const typingUsers = useRecoilValue(selectedChatTypingUsersState);
  const label = useMemo(
    () => formatTypingLabel(typingUsers),
    [typingUsers],
  );

  if (!label) {
    return null;
  }

  return (
    <div className="conversation-typing-indicator" role="status" aria-live="polite">
      <span className="conversation-typing-indicator__dots" aria-hidden>
        <span />
        <span />
        <span />
      </span>
      <span className="conversation-typing-indicator__text">{label}</span>
    </div>
  );
};

export default TypingIndicator;
